import { MeetingsModel } from '@w3lcome/types';
import logSentryException from '_/helpers/logSentryException';
import { useMeetingsContext } from '_/hooks/MeetingsProvider';
import * as Localization from 'expo-localization';
import moment from 'moment';
import React, { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, RefreshControl } from 'react-native';
import { showMessage } from 'react-native-flash-message';
import { useDispatch } from 'react-redux';

import { getMeetingDetailsRequest } from '_/store/modules/meeting/actions';

import MeetingCard from '../MeetingCard';
import styles from './styles';

export default function PastMeetings() {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();

  const [reachedEnd, setReachedEnd] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const { getMeetings, meetings, meetingsState, loadMoreMeetings } = useMeetingsContext();

  const pastMeetings = useMemo(() => {
    return meetings;
  }, [meetings]);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    getMeetings({
      '$sort[start]': -1,
    });
    const time = Math.floor(Math.random() * 1500) + 500;
    setTimeout(() => setRefreshing(false), time);
  }, []);

  const loadMore = useCallback(async () => {
    try {
      setRefreshing(true);

      if (!reachedEnd) {
        if (meetings.length < meetingsState.total) {
          loadMoreMeetings({
            $limit: 1000,
            $skip: meetingsState.limit,
            '$sort[start]': -1,
          });
        }

        if (pastMeetings.length === 0) {
          setReachedEnd(true);
        }
      }
      setRefreshing(false);
    } catch (error) {
      logSentryException({
        error,
        file: 'pastMeetings.js',
        message: 'Error at loadMore function',
      });
      showMessage({
        message: translate('personalInvites.loadingError'),
        type: 'danger',
      });
      setRefreshing(false);
    }
  }, [meetings, meetingsState, pastMeetings]);

  function handleTimezone(date: Date, timezone: string) {
    return moment(date).tz(timezone || Localization.timezone || 'America/Sao_Paulo');
  }

  function handleGetMeetingsDetails(meeting: MeetingsModel) {
    dispatch(getMeetingDetailsRequest(meeting));
  }

  function renderItems(meeting: MeetingsModel) {
    if (handleTimezone(meeting.end, meeting.timezone).unix() <= moment().unix()) {
      return <MeetingCard meeting={meeting} getMeetingDetails={handleGetMeetingsDetails} />;
    }

    return null;
  }

  return (
    <FlatList
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      onEndReached={loadMore}
      onEndReachedThreshold={0.2}
      style={styles.container}
      contentContainerStyle={{ paddingBottom: 80 }}
      data={pastMeetings}
      keyExtractor={(item) => item.id}
      renderItem={({ item: meeting }) => renderItems(meeting)}
    />
  );
}
